import BizExp from './BizExp/index.vue'
import Mail from './Mail/index.vue'
import Playground from './Playground/index.vue'

export default [
  { path: '/mail', component: Mail, meta: { auth: 'corp' } },
  { path: '/bizexp', component: BizExp, meta: { auth: 'corp' } },
  { path: '/playground', component: Playground, meta: { auth: 'corp' } }
]